import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

import './css/reset.css'

import Header from './components/Header.js'
import Main from './components/Main.js'
import Visual from './components/Visualization.js'
import Graph from './components/Graph.js'
import DataProduct from './components/DataProduct.js'
import Notice from './components/Notice.js'
import Footer from './components/Footer.js';
import Admin from './components/Admin/Admin.js';
import AdminLogin from './components/Admin/AdminLogin.js';
import { useEffect, useState } from 'react';
import Map from './components/Map.js';
import DeveloperCenter from './components/DeveloperCenter.js';

import { content } from './components/Content.js';

// ScrollToTop 컴포넌트
function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // 브라우저의 자동 스크롤 복원 기능 비활성화
        if (window.history.scrollRestoration) {
            window.history.scrollRestoration = 'manual';
        }
        window.scrollTo(0, 0);
    }, [pathname]); // pathname이 바뀔 때마다 (페이지 이동/새로고침 시) 실행

    return null;
}

// App 내부에서 useLocation 사용을 위해 컴포넌트 분리
function AppContent() {
    const location = useLocation();
    const isMapPage = location.pathname === '/map' || location.pathname === '/Map';

    // 2. 언어 상태(state)를 추가합니다. (기본 'ko')
    const [lang, setLang] = useState('ko');

    // 3. 언어 변경 함수를 만듭니다.
    const handleLangToggle = () => {
      setLang(lang === 'ko' ? 'en' : 'ko');
    };

    return (
        <>
            <ScrollToTop />
            <Header lang={lang} onLangToggle={handleLangToggle} content={content[lang]} />
            <Routes>
                <Route path="/" element={<Main content={content[lang]} />}/>
                <Route path="/visual" element={<Visual content={content[lang]} />}/>
                <Route path="/graph" element={<Graph content={content[lang]} />}/>
                <Route path="/product" element={<DataProduct content={content[lang]} />} />
                <Route path="/notice" element={<Notice content={content[lang]} />} />
                <Route path="/map" element={<Map content={content['ko']} />} />
                <Route path="/developer" element={<DeveloperCenter content={content[lang]} />} />

            </Routes>
            {!isMapPage && <Footer content={content[lang]} />}
        </>
    );
}

// 최종 App 함수
function App() {
    return (
        <ThemeProvider theme={theme}>
            <Router>
                <AppContent />
            </Router>
        </ThemeProvider>
    );
}

export default App;